module.exports = __webpack_public_path__ + "static/media/id-card.e0659561.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/id-card.svg
// module id = 462
// module chunks = 0